import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import PlayerLocksList from './player-locks-list';
import PlayerLock from './index';

class PlayerLockByMode extends Component {
    isRankOrExcludedMode() {
        const {activeMode} = this.props;
        return inArray(activeMode, [
            Const.CAPTAIN_MODE,
            Const.STAR_MODE,
            Const.PRO_MODE,
            Const.FLEX_MODE,
            Const.EXCLUDED_MODE,
        ]);
    }

    render() {
        const {playerId, playerMode, className = 'lock-btn'} = this.props;

        if (this.isRankOrExcludedMode()) {
            return <PlayerLock className={className} playerId={playerId} mode={playerMode} />;
        }

        return <PlayerLocksList playerId={playerId} />;
    }
}

export default PlayerLockByMode;
